module.exports = __webpack_public_path__ + "static/media/tick.b685cef5.mp3";